/**
 * Bridge — a gold-toned connector bar spanning the full width of the tooth,
 * hinting at the mesial + distal connectors to adjacent abutments. A subtle
 * shine and slotted joint lines sell the metallurgy.
 */
import { uid } from "./_shared";

export default function Bridge({ toothId }) {
  const gid = uid("brdg", toothId);
  return (
    <g style={{ pointerEvents: "none" }}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#F6DA8A" />
          <stop offset="45%"  stopColor="#B9873B" />
          <stop offset="100%" stopColor="#6E4A18" />
        </linearGradient>
      </defs>

      {/* Full-width connector bar */}
      <path d="M 2 74 Q 30 70 58 74 L 58 84 Q 30 88 2 84 Z"
            fill={`url(#${gid})`}
            stroke="#4A2D08" strokeWidth={0.6} />

      {/* Mesial joint slot */}
      <rect x={4}  y={76} width={2} height={6} fill="#4A2D08" opacity={0.75} />
      {/* Distal joint slot */}
      <rect x={54} y={76} width={2} height={6} fill="#4A2D08" opacity={0.75} />

      {/* Top specular highlight */}
      <path d="M 6 75 Q 30 71 54 75"
            fill="none" stroke="#FFF3C4" strokeOpacity={0.65} strokeWidth={0.9} />
      {/* Bottom shadow */}
      <path d="M 6 84 Q 30 87 54 84"
            fill="none" stroke="#2A1804" strokeOpacity={0.4} strokeWidth={0.6} />

      {/* Center pontic indicator diamond */}
      <path d="M 30 76 L 33 79 L 30 82 L 27 79 Z"
            fill="#4A2D08" opacity={0.85} />
    </g>
  );
}
